export default __webpack_public_path__ + "locales/lo-LA/Files.json?hash=f61b114d1dc7102cd8e6d7b582e8ab00";